import { Amplify } from 'aws-amplify'
// Completes the Google/Apple hosted-UI redirect (exchanges the ?code= for tokens) on whichever page
// the user lands back on. v5 did this implicitly; v6 needs the listener imported.
import 'aws-amplify/auth/enable-oauth-listener'

// Comma-separated: the site is served at more than one address (app.thepath4life.org, www.thepath4life.com).
// Amplify picks the entry matching the page the user is on; each must be an allowed callback in Cognito.
const urlList = (value?: string) =>
  (value || '')
    .split(',')
    .map((url) => url.trim())
    .filter(Boolean)
const redirectSignIn = urlList(process.env.REACT_APP_AWS_OAUTH_REDIRECT_SIGN_IN)
const redirectSignOut = urlList(process.env.REACT_APP_AWS_OAUTH_REDIRECT_SIGN_OUT)

Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: process.env.REACT_APP_AWS_USER_POOL_ID as string,
      userPoolClientId: process.env.REACT_APP_AWS_USER_POOL_CLIENT_ID as string,
      loginWith: {
        oauth: {
          domain: process.env.REACT_APP_AWS_OAUTH_DOMAIN as string,
          // v5 was never given scopes and sent an empty `scope=`, which makes Cognito grant everything
          // the app client allows. Keep sending nothing so tokens carry exactly the same scopes.
          scopes: [],
          redirectSignIn,
          redirectSignOut,
          responseType: (process.env.REACT_APP_AWS_OAUTH_RESPONSE_TYPE as 'code' | 'token') || 'code',
        },
      },
    },
  },
})
